
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI_FailedDeployments() {

    const [title] = useState("Failed Deployments - DevOpsKPI")
    const [summary] =  useState("Key Performance Indicators of Software deployment and development in BD MMS for Failed Deployments.")
    const [categories] = useState(["TbAlertTriangle","BiRocket"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColorFailed, setBubColorFailed] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColorFailed(new Map([
            ["ABORTED", "#e7b416"],
            ["SUCCESS", "#2dc937"],
            ["FAILURE", "#cc3232"],
            ["NOT_BUILT", "#f28e2c"],
            ["UNSTABLE", "#db7b2b"],
            ["Success", "#2dc937"],
            ["Failed", "#cc3232"],
            ["TimedOut", "#f28e2c"],
            ["Cancelled", "#e7b416"],
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevOpsKPI_FailedDeployments/DevOpsKPI_FailedDeployments.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        Failed deployments metric is tracked over time to create a correlation between time, root failure cause and impact to the deployment. This metric is measured per release and during specific time periods.
                        </p>
                         <p>
                         Failed deployments can lead to an increase in potential rollbacks.
                         </p>
                         <p>
                         The main data sources are Jenkins, AWS and Unit Testing.
                         </p>
                         <p>
                         <a href="/DevOpsKPI">Devops KPIs</a>
                         </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                AWS Metrics
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            AWS Systems Manager Agent Deployment Records
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedSSM}
                            axis = {{y:"Records"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    AWS Systems Manager Agent (SSM Agent) captures data on if the deployment is successful, times out, cancelled or fails.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            AWS Systems Manager Agent Deployment Records out of 100%
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedSSM100}
                            axis = {{y:"Records %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    AWS Systems Manager Agent (SSM Agent) captures data on if the deployment is successful, times out, cancelled or fails normalized.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Jenkins Metrics
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Jenkins StdOut Error High Level Results
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedstdout_simple}
                            axis = {{y:"Count"}}
                            tooltip={"Error"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Stdout Error, also known as standard output error is the result of a failure in Jenkins.
                    </p>
                    <p>
                    These are high level results simplified, the verbose results are on <a href="https://bdlytics.stage.bdservices.io/dashboard/DevOpsKPI">Devops KPI</a>.
                    </p>
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Jenkins StdOut Errors by Project
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedJenkinsSTDOut}
                            axis = {{y:"Count"}}
                            tooltip={"Project"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    <p>
                    Stdout Error, also known as standard output error is the result of a failure in Jenkins.
                    </p>
                    <p>
                    These are high level results simplified, the verbose results are on <a href="https://bdlytics.stage.bdservices.io/dashboard/DevOpsKPI">Devops KPI</a>.
                    </p>
                    </Typography>
                    </div>
                </Paper>



                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Artifactory linked Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuildNotNull}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Jenkins Deployments Failures associated to projects in Artifactory.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Artifactory linked Jenkins Deployment Failure Metrics 100%
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100PercentNotNull}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={""}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Jenkins Deployments Failures normalized associated to projects in Artifactory.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Overall Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Overall Jenkins Deployments Failures across all organizations.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            Overall Jenkins Deployment Failure Metrics out of 100 percent across all organizations.
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100Percent}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Overall Jenkins Deployments Failures out of 100 percentage.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Devops Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuildbddevops}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Devops Jenkins Deployment Failure Metrics 100%
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100Percentbddevops}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Pharmogistics Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuildbdpharmogistics}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Pharmogistics Jenkins Deployment Failure Metrics 100%
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100Percentbdpharmogistics}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Pyxis Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuildbdpyxis}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100Percentbdpyxis}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Overall Jenkins Deployments Failures out of 100 percentage.
                            </Typography>
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                            BD Pyxis Jenkins Deployment Failure Metrics
                            </Typography>
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuildbdpyxis}
                            axis = {{y:"Build Time"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    </div>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                        </div>
                    </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
<StackBarChart
                            data={data.stackedResultBuild100Percentbdpyxis}
                            axis = {{y:"Build %"}}
                            colors={bubbleColorFailed}
                            tooltip={"Status"}
                            width={800}
                            height={400}>
                        </StackBarChart>
                </Grid>
                    <div className="subText">
                    <Typography>
                    Overall Jenkins Deployments Failures normalized.
                            </Typography>
                    </div>
                </Paper>














            </div >
        )
    }
}

export default DevOpsKPI_FailedDeployments